import React from "react";
import { useWizard, DAYS } from "../../lib/wizardStore";

export default function HoursStep() {
  const { state, updateHours } = useWizard();

  return (
    <div className="space-y-5">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900">
          When are you open?
        </h2>
        <p className="text-slate-500 mt-2">
          Customers see this directly on Google. Toggle a day off if you’re closed.
        </p>
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white divide-y divide-slate-100">
        {DAYS.map((day) => {
          const h = state.hours[day];
          return (
            <div key={day} className="flex flex-wrap items-center gap-3 sm:gap-4 px-4 sm:px-5 py-3.5">
              <div className="w-24 font-medium text-slate-800 text-sm">{day}</div>

              <button
                type="button"
                data-testid={`toggle-${day.toLowerCase()}`}
                onClick={() => updateHours(day, { closed: !h.closed })}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                  h.closed ? "bg-slate-300" : "bg-emerald-500"
                }`}
                aria-label={`${day} ${h.closed ? "closed" : "open"}`}
              >
                <span
                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${
                    h.closed ? "translate-x-0.5" : "translate-x-[22px]"
                  }`}
                />
              </button>

              <span className={`text-xs font-medium ${h.closed ? "text-slate-400" : "text-emerald-600"}`}>
                {h.closed ? "Closed" : "Open"}
              </span>

              <div className="flex items-center gap-2 ml-auto">
                <input
                  type="time"
                  data-testid={`open-${day.toLowerCase()}`}
                  disabled={h.closed}
                  value={h.open}
                  onChange={(e) => updateHours(day, { open: e.target.value })}
                  className="w-[110px] rounded-lg bg-slate-50 border border-transparent py-1.5 px-2 text-sm focus:bg-white focus:border-emerald-500 outline-none disabled:opacity-40"
                />
                <span className="text-slate-400 text-sm">–</span>
                <input
                  type="time"
                  data-testid={`close-${day.toLowerCase()}`}
                  disabled={h.closed}
                  value={h.close}
                  onChange={(e) => updateHours(day, { close: e.target.value })}
                  className="w-[110px] rounded-lg bg-slate-50 border border-transparent py-1.5 px-2 text-sm focus:bg-white focus:border-emerald-500 outline-none disabled:opacity-40"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
